module.exports = __webpack_public_path__ + "static/media/Country-Club-Village-PhaseIII-First-Amendment.f44f91fe.pdf";